angular.module('galilai.creator').controller('MediaController', function ($scope, $http, $timeout, api, $rootScope, mediaService, fontsService) {
    const MAX_UPLOAD_SIZE_IN_MB = 500

    const spec = {
        'image': {
            kind: 'image',
            title: gettext('label.media_select_image'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_images'),
                    action: 'getMedias',
                    elements: {
                        upload: 'image/*',
                        project: true,
                        collection: true,
                    },
                    actions: {
                        'select': true,
                        'remove': true,
                        'removeBg': true,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'pexels',
                    name: gettext('tab.media_images_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'pexels',
                            default: 'social media',
                            paginated: true,
                            related: true,
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': true,
                        'favorite': false,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'video': {
            kind: 'video',
            title: gettext('label.media_select_video'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_videos'),
                    action: 'getMedias',
                    elements: {
                        upload: 'video/*',
                        project: true,
                        collection: true,
                    },
                    actions: {
                        'select': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'pexels',
                    name: gettext('tab.media_videos_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'pexels',
                            default: 'social media',
                            paginated: true,
                            related: true,
                        }
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'audio': {
            kind: 'audio',
            title: gettext('label.media_select_audio'),
            tabs: [
                {
                    id: 'audio_database',
                    name: gettext('tab.media_audio_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'audio_database',
                            hideInput: true,
                            suggestions: [
                                {
                                    value: '',
                                    label: gettext('tag.audio_all')
                                },
                                {
                                    value: 'upbeat',
                                    label: gettext('tag.audio_upbeat')
                                },
                                {
                                    value: 'happy',
                                    label: gettext('tag.audio_happy')
                                },
                                {
                                    value: 'inspiring',
                                    label: gettext('tag.audio_inspiring')
                                },
                                {
                                    value: 'chill',
                                    label: gettext('tag.audio_chill')
                                }
                            ]
                        },
                        preview: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    }
                },
                {
                    id: 'user',
                    name: gettext('tab.media_my_audio'),
                    action: 'getMedias',
                    elements: {
                        upload: 'audio/*',
                        project: true,
                        collection: true,
                        preview: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    }
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        preview: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'elements': {
            kind: 'elements',
            title: gettext('label.media_select_elements'),
            tabs: [
                {
                    id: 'icons_db',
                    name: gettext('tab.media_icons_database'),
                    action: 'doSearch',
                    elements: {
                        search: {
                            source: 'icons_db',
                            default: gettext('icons.suggested.phone'),
                            _suggestions: [
                                {
                                    value: gettext('icons.suggested.phone'),
                                    label: gettext('icons.suggested.phone')
                                },
                                {
                                    value: gettext('icons.suggested.arrow'),
                                    label: gettext('icons.suggested.arrow')
                                },
                                {
                                    value: gettext('icons.suggested.heart'),
                                    label: gettext('icons.suggested.heart')
                                },
                                {
                                    value: gettext('icons.suggested.bubble'),
                                    label: gettext('icons.suggested.bubble')
                                },
                                {
                                    value: gettext('icons.suggested.shopping'),
                                    label: gettext('icons.suggested.shopping')
                                },
                                {
                                    value: gettext('icons.suggested.local'),
                                    label: gettext('icons.suggested.local')
                                },
                                {
                                    value: gettext('icons.suggested.star'),
                                    label: gettext('icons.suggested.star')
                                },
                            ],
                        },
                        preview: false,
                        name: false,
                        smallMedia: true,
                        hideActions: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': false,
                    }
                },
            ]
        },
        'font': {
            kind: 'font',
            title: gettext('label.media_select_fonts'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_fonts'),
                    action: 'getMedias',
                    elements: {
                        upload: 'font/*',
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
        'product': {
            kind: 'product',
            title: gettext('label.media_select_product'),
            tabs: [
                {
                    id: 'user',
                    name: gettext('tab.media_my_products'),
                    action: 'getMedias',
                    elements: {
                        create: true,
                        project: true,
                        collection: true,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'edit': true,
                        'remove': true,
                        'removeBg': false,
                        'favorite': true,
                        'unfavorite': false,
                    },
                },
                {
                    id: 'favorite',
                    name: gettext('tab.favorites'),
                    action: 'getMedias',
                    elements: {
                        upload: null,
                        project: true,
                        collection: false,
                        name: true,
                    },
                    actions: {
                        'select': true,
                        'remove': false,
                        'removeBg': false,
                        'favorite': false,
                        'unfavorite': true,
                    },
                },
            ]
        },
    }

    $scope.view = {}
    $scope.previewMap = {}

    const HOME_COLLECTION = {
        'value': '__home__',
        'label': gettext('label.folder_home')
    }
    $scope.initView = function(kind) {
        $scope.view = {
            spec: JSON.parse(JSON.stringify(spec[kind], null, 2)),
            currentTab: null,
            uploading: false,
            selectedMedia: null,
            customAction: null,
            loading: false,
            medias: [],
            relatedSearches: [],
            nextPage: null,
            collections: [
                JSON.parse(JSON.stringify(HOME_COLLECTION, null, 2))
            ],
            collection: '__home__',
        }
        try {
            $scope.view.spec.tabs.forEach(function(tab) {
                if (tab.elements.search && tab.elements.search.default) {
                    let defaultValue = $scope.getDefault(tab.id)
                    if (defaultValue != 'null' && defaultValue != 'undefined' && defaultValue && defaultValue.trim().length > 0) {
                        tab.elements.search.default = defaultValue
                    }
                }
            })
        } catch (e) {
            // TASK - No handling
        }

        track('Editor Media Show', {
            kind: kind
        })

        initModalAdjust()
    }

    function initModalAdjust() {
        window.addEventListener('resize', adjustModal);
        let modal = document.querySelector('#images-modal');
        // On hidden
        modal.addEventListener('hidden.bs.modal', function() {
            window.removeEventListener('resize', adjustModal);
        })
    }

    function adjustModal() {
        $timeout(function() {
            const modalContent = document.querySelector('#images-modal .modal-content');
            const mediaScrollWrapper = document.querySelector('#images-modal .media-scroll-wrapper');
            const windowHeight = window.innerHeight;

            if (mediaScrollWrapper.scrollHeight > windowHeight - 200) {
                mediaScrollWrapper.style.maxHeight = (windowHeight - 200) + 'px';
                mediaScrollWrapper.style.overflowY = 'scroll';
            } else {
                mediaScrollWrapper.style.maxHeight = 'none';
            }
        }, 200);
    }

    $scope.$watch('config', function() {
        if ($scope.config && $scope.config.kind) {
            $scope.initView($scope.config.kind)

            if ($scope.config.projectId) {
                $scope.view.projectId = $scope.config.projectId
            }
            $scope.init()
        }
    })

    $rootScope.$on('media.show', function(event, data) {
        if ($scope.config && $scope.config.kind) {
            return
        }
        $scope.initView(data.kind)

        if (data && data.projectId) {
            $scope.view.projectId = data.projectId
        }
        $scope.view.selectedSource = null
        $scope.view.customAction = null
        if (data && data.source) {
            $scope.view.selectedSource = data.source
        }
        if (data && data.customAction) {
            $scope.view.customAction = data.customAction
        }
        if (data && data.multiple) {
            $scope.view.multiple = data.multiple
        }
        $scope.init()
    })
    $rootScope.$on('media.item.created', function(event, data) {
        if (!data || data.kind != $scope.view.spec.kind) {
            return
        }
        $scope.getMedias()
    })

    $scope.init = function() {
        $scope.getCollections()
        $scope.getProjects()
        $scope.changeMediaTab($scope.view.spec.tabs[0])
    }

    $scope.changeMediaTab = function(tab) {
        $scope.view.currentTab = tab
        if (tab.elements && tab.elements.search && tab.elements.search.default && !$scope.view.searchInput) {
            $scope.view.searchInput = tab.elements.search.default
        }
        $scope[tab.action]()
    }

    $scope.create = function() {
        if (!$scope.view.currentTab.elements.create) {
            return
        }
        $rootScope.$emit('media.item.show', {
            source: 'media',
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
        })
    }

    $scope.editMedia = function(media) {
        if (!$scope.view.currentTab.actions.edit) {
            return
        }
        $rootScope.$emit('media.item.edit', {
            source: 'media',
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
            item: media,
        })
    }

    // Refactor
    $scope.uploadMedia = function(file) {
        if (!file) {
            showError(gettext('error.invalid.file_type'))
            return;
        }
        // Limit number max files

        var formData = new FormData();
        for (var i = 0; i < file.length; i++) {
            formData.append('media', file[i]);
            formData.append('name', file[i].name);
        }

        // Validate max size 100mb (what happens if there are multiple files?, check sum?)
        // Validate max number of files
        let totalSize = 0
        for (var i = 0; i < file.length; i++) {
            totalSize += file[i].size
        }

        if (totalSize > MAX_UPLOAD_SIZE_IN_MB * 1024 * 1024) {
            showError(gettext('error.invalid.max_size', MAX_UPLOAD_SIZE_IN_MB + 'MB'))
            return
        }

        formData.append('projectId', $scope.view.projectId);
        formData.append('collection', $scope.view.collection);

        let token = localStorage.getItem('auth.token');

        $scope.view.uploading = true
        // TODO - Refactor
        $http({
          method: 'POST',
          url: window.BASE_URL + '/api/media/upload',
          data: formData,
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': undefined
          },
          transformRequest: angular.identity
        })
        .then(function(response) {
            $scope.view.uploading = false
            $scope.getMedias()
            $scope.getCollections()
        })
        .catch(function(error) {
            $scope.view.uploading = false
            showError(gettext('error.invalid.image'))
        }).finally(function() {
            $scope.view.uploading = false
            // Clear input #imageInput
            angular.element('#imageInputModal').val(null);
        })
    }

    $scope.selectMedia = function(media) {
        if ($scope.view.multiple) {
            if (!$scope.view.selectedMedia) {
                $scope.view.selectedMedia = []
            }
            const index = $scope.view.selectedMedia.findIndex(selected => selected._id === media._id);
            if (index > -1) {
                $scope.view.selectedMedia.splice(index, 1);
                media.active = false;
            } else {
                $scope.view.selectedMedia.push(media);
                media.active = true;
            }
        } else {
            $scope.view.medias.forEach(function(media) {
                media.active = false;
            });
            media.active = true;
            $scope.view.selectedMedia = [media];
        }

        if ($scope.onSelect) {
            $scope.onSelect($scope.view.selectedMedia);
        }
        $timeout(angular.noop)
    };

    $scope.selectSuggestion = function(suggestion) {
        $scope.view.searchInput = suggestion.value
        $scope.doSearch()
    }

    $scope.saveSearch = function() {
        try {
            localStorage.setItem('media.search.' + $scope.view.spec.kind + '.' + $scope.view.currentTab.id, $scope.view.searchInput)
        } catch (e) {
            // TASK - No handling
        }
    }

    $scope.getDefault = function(tabId) {
        try {
            return localStorage.getItem('media.search.' + $scope.view.spec.kind + '.' + tabId)
        } catch (e) {
            return ''
        }
    }

    let timerSearchRelated = null
    $scope.searchRelated = function() {
        if (timerSearchRelated) {
            $timeout.cancel(timerSearchRelated)
        }
        timerSearchRelated = $timeout(function() {
            $scope.saveSearch()
            api.relatedSearch({
                query: $scope.view.searchInput,
            }).then(function(response) {
                $timeout(function() {
                    $scope.view.relatedSearches = response.data
                    console.log('Related searches', $scope.view.relatedSearches)
                })
            }).catch(function() {
                // TASK - No handling
            })
        }, 500)
    }

    $scope.doSearch = function(page) {
        $scope.view.loading = true

        page = page || 1
        if (page == 1) {
            $scope.searchRelated()
        }

        api.searchMedia({
            kind: $scope.view.spec.kind,
            source: $scope.view.currentTab.elements.search.source,
            query: $scope.view.searchInput,
            page: page,
        }).then(function(response) {
            $timeout(function() {
                if (page == 1) {
                    $scope.view.medias = response.data.medias
                } else {
                    $scope.view.medias = $scope.view.medias.concat(response.data.medias)
                }
                $scope.view.nextPage = response.data.next
                $scope.afterFetchingMedias($scope.view.medias)
                adjustModal()
            })
        }).catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $scope.view.loading = false
            $timeout(angular.noop)
        })
    }

    $scope.onScroll = function() {
        if ($scope.view.loading) {
            return
        }
        $scope.loadNextPage()
    }

    $scope.loadNextPage = function() {
        if ($scope.view.loading) {
            return
        }
        if (!$scope.view.nextPage) {
            return
        }
        $scope.doSearch($scope.view.nextPage)
    }

    $scope.afterFetchingMedias = function(medias) {
        // If kind is font load fonts
        if ($scope.view.spec.kind == 'font') {
            medias.map(function(media) {
                let fullFontName = media.data.url.split('/').pop()
                fontsService.loadDynamic(fullFontName)
            })
        }
    }

    $scope.getMedias = function() {
        $scope.view.loading = true
        let params = {}
        if ($scope.view.projectId) {
            params.projectId = $scope.view.projectId
        }
        if ($scope.view.collection && typeof $scope.view.collection !== 'undefined' && $scope.view.collection.trim().length > 0) {
            params.collection = $scope.view.collection
        }
        params.kind = $scope.view.spec.kind

        if ($scope.view.currentTab && $scope.view.currentTab.id) {
            params.tab = $scope.view.currentTab.id
        }

        api.getMedias(params).then(function(response) {
            $timeout(function() {
                $scope.view.medias = response.data
                $scope.afterFetchingMedias($scope.view.medias)
                adjustModal()
            })
        })
        .catch(function() {
            // TASK - No handling
        })
        .finally(function() {
            $scope.view.loading = false
            $timeout(angular.noop)
        })
    }

    $scope.onChangeProject = function() {
        $timeout(function() {
            $scope.getMedias()
        })
    }

    $scope.onChangeCollection = function() {
        $timeout(function() {
            $scope.getMedias()
        })
    }

    $scope.showAllMedias = function() {
        $timeout(function() {
            $scope.view.projectId = null
            $scope.view.collection = null
            $scope.getMedias()
        })
    }

    $scope.getCollections = function() {
        api.getCollections($scope.view.spec.kind).then(function(response) {
            // Merge with collections
            let collections = [
                JSON.parse(JSON.stringify(HOME_COLLECTION, null, 2))
            ]
            collections = collections.concat(response.data.collections.map(function(collection) {
                return {
                    value: collection,
                    label: collection
                }
            }))

            $scope.view.collections = collections
            $timeout(angular.noop)
        })
        .catch(function() {
        })
    }

    $scope.getProjects = function() {
        api.getProjects().then(function(response) {
            $timeout(function() {
                $scope.projects = response.data
                $scope.view.projects = response.data.map(function(project) {
                    return {
                        value: project._id,
                        label: project.name
                    }
                })
            })
        })
        .catch(function() {
            // TASK - No handling
        })
    }

    $scope.removeMedia = function(media) {
        let mediaId = media._id

        showConfirm(gettext('label.are_you_sure'), null, function(status) {
            if (status) {
                angular.noop()
                api.removeMedia(mediaId).then(function(response) {
                    $scope.view.medias = $scope.view.medias.filter(function(media) {
                        return media._id != mediaId
                    })
                    $timeout(angular.noop)
                }).catch(function(response) {
                    if (response?.data?.error == 'media_in_use') {
                        showError(gettext('error.media_in_use'))
                    }
                    // TASK - No handling
                })
            }
        })
    }

    $scope.favoriteMedia = function(media) {
        let mediaId = media._id
        if (!$scope.view.projectId) {
            showError(gettext('error.missing_project_favorite'))
            return
        }
        api.addFavorite({
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            value: mediaId
        }).then(function(response) {
            if (response.data && response.data.status && response.data.status == 'success') {
                showSuccess(gettext('label.success_generic'))
            } else {
                showError(gettext('error.generic'))
            }
        }).catch(function() {
            showError(gettext('error.generic'))
        })
    }

    $scope.unfavoriteMedia = function(media) {
        let mediaId = media._id
        if (!$scope.view.projectId) {
            showError(gettext('error.missing_project_favorite'))
            return
        }
        api.removeFavorite({
            kind: $scope.view.spec.kind,
            projectId: $scope.view.projectId,
            value: mediaId
        }).then(function(response) {
            if (response.data && response.data.status && response.data.status == 'success') {
                showSuccess(gettext('label.success_generic'))
                $scope.getMedias()
            } else {
                showError(gettext('error.generic'))
            }
        }).catch(function() {
            showError(gettext('error.generic'))
        })
    }

    $scope.removeMediaBackground = function(media) {
        $rootScope.mainLoading = true

        api.removeMediaBackground({
            url: media.data.url,
            projectId: $scope.view.projectId,
            collection: $scope.view.collection,
        }).then(function(response) {
            $scope.changeMediaTab($scope.view.spec.tabs[0])
            $scope.resetScroll()
        }).catch(function() {
            // TASK - No handling
        }).finally(function(){
            $rootScope.mainLoading = false
            $timeout(angular.noop)
        })
    }

    $scope.resetScroll = function() {
        let scrollWrapper = document.querySelectorAll('.media-scroll-wrapper')
        // Reset scroll for all
        scrollWrapper.forEach(function(wrapper) {
            wrapper.scrollTop = 0
        })
    }

    $scope.confirm = function(actionType) {
        let maxUpgradeKinds = [
            'audio', 'video',
        ]
        if (!$rootScope.isMaxCustomer() && maxUpgradeKinds.indexOf($scope.view.spec.kind) != -1 && $scope.view.selectedMedia.length > 0) {
            if ($scope.view.spec.kind == 'audio') {
                $rootScope.showUpgrade('Select Audio')
            } else if ($scope.view.spec.kind == 'video') {
                $rootScope.showUpgrade('Select Video')
            }
            return false
        }
        let data = $scope.view.selectedMedia.map(function(media) {
            return Object.assign({}, {_id: media._id}, media.data)
        })
        $rootScope.$broadcast('media.selected', data, $scope.view.selectedSource, actionType)
        angular.element('#images-modal').modal('hide')
    }

    $scope.getMediaStyle = function(media) {
        if ($scope.view.spec.kind == 'image' || $scope.view.spec.kind == 'product') {
            let mediaURL = media.data.url
            if (mediaURL.includes('images.pexels') && media.data.thumb) {
                mediaURL = media.data.thumb
            }
            return {
                'background-image': 'url(' + mediaURL + '), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc)',
            }
        }
        if ($scope.view.spec.kind == 'video') {
            let mediaURL = media.data.thumb
            return {
                'background-image': 'url(' + mediaURL + '), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc), linear-gradient(45deg, #ccc 25%, transparent 25%, transparent 75%, #ccc 75%, #ccc)',
            }
        }
        if ($scope.view.spec.kind == 'elements') {
            return {
                'background-image': 'url(' + media.data.url + ')',
            }
        }
        if ($scope.view.spec.kind == 'audio') {
            return {
                'width': '200px',
                'height': '80px',
            }
        }
        if ($scope.view.spec.kind == 'font') {
            return {
                'width': '200px',
                'height': '50px',
            }
        }
        return {}
    }

    $scope.getMediaNameStyle = function(media) {
        if ($scope.view.spec.kind == 'font') {
            let fullName = media.data.url.split('/').pop()
            return {
                'font-family': `"${fullName}"`,
                'font-size': '16px',
                'line-height': '50px',
            }
        }
        return {}
    }
    $scope.previewMedia = function(media, $event) {
        $event.stopPropagation()
        mediaService.previewAudio(media)
    }
})
